import { ADD_ACTIVITY_BANNER_ACTION, DELETE_ACTIVITY_BANNER_ACTION, DELETE_ALL_ACTIVITY_BANNER_ACTION, UPDATE_ACTIVITY_BANNER_ACTION } from '../constants/activityBannerConstants';

/**
 * Reducer function for managing activity banner state
 *
 * @param {object} state - Current state of the alarm events list.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const activityBannerReducer = (state = { activityMessages: [] }, action) => {
    switch (action.type) {
        case ADD_ACTIVITY_BANNER_ACTION:
            {
                return {
                    ...state,
                    activityMessages: [...(state.activityMessages ?? []), action.payload,]
                };
            }
        case DELETE_ACTIVITY_BANNER_ACTION:
            {
                // * the message id which will be used to delete the existing message
                const activityMessageIdToBeDeleted = action?.payload?.messageId;
                return {
                    ...state,
                    activityMessages: state?.activityMessages?.filter((message) => message?.messageId != activityMessageIdToBeDeleted,) ?? [],
                };
            }
        case DELETE_ALL_ACTIVITY_BANNER_ACTION: {
            return {
                ...state,
                activityMessages: [],
            };
        }
        case UPDATE_ACTIVITY_BANNER_ACTION:
            {
                // * the message id which will be used to update the existing message
                const activityMessageIdToBeUpdated = action?.payload?.messageId;
                const existingActivityMessages = (state.activityMessages ?? []).filter((message) => message?.messageId != activityMessageIdToBeUpdated,);

                return {
                    ...state,
                    activityMessages: [
                        ...existingActivityMessages,
                        action.payload,
                    ]
                };
            }
    }

    return state;
};
